import { useMutation } from "react-query"
import api from "../client"

const postData = async () => {
    const { data } = await api.post(
        "/logout",
        {}
    )
    return data
}

export const useAuthLogout = () => {
    return useMutation(() => {
        return postData()
    })
}
